import React from 'react';

import { Button } from '@tecma/ds';
import { useSelector } from 'react-redux';

import { useFooterSection } from 'hooks/useFooterSection';
import { applicationStateSelectors } from 'store/slices/applicationState/selectors';

import './footer-section.scss';

interface FooterSectionRequiredProps {
  showContactUsModal: () => void;
  forceContactUsDisplay?: boolean;
}

// Optional Props
interface FooterSectionOptionalProps {}

// Combined required and optional props to build the full prop interface
export interface FooterSectionProps extends FooterSectionRequiredProps, FooterSectionOptionalProps {}

export const FooterSection: React.FC<FooterSectionProps> = React.memo(({ showContactUsModal, forceContactUsDisplay }) => {
  const displayName = useSelector(applicationStateSelectors.selectDisplayName);

  const { showContactButton, sectionContent, sectionButtonLabel, onClick } = useFooterSection(showContactUsModal, forceContactUsDisplay);

  return (
    <div className='footer-section'>
      {showContactButton && <h3>{displayName}</h3>}
      <span>{sectionContent}</span>
      <Button iconName={!showContactButton ? 'plus' : undefined} onClick={onClick} outlined>
        {sectionButtonLabel}
      </Button>
    </div>
  );
});
